import Swiper from 'swiper/bundle';

$(function() {
	if ($(window).width() < 576) {
		handleSwiper();
	}
});


function handleSwiper() {
	var swiper = new Swiper('.news-and-insights .swiper', {
		mousewheel: false,
		initialSlide: 0,
		grabCursor: true,
		centeredSlides: false,
		slidesPerView: '2',
		//autoHeight: true, //enable auto height [not working on vertical scroll]
		spaceBetween: 25,
	});
}